import React from 'react'
import styled from 'styled-components'
import { node } from 'prop-types'

import { navHeightMobile, navHeight } from 'styles/global'
import { media } from 'styles/media'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - ${navHeightMobile});
  overflow: hidden;

  ${media.medium`
    height: calc(100vh - (${navHeight}));
  `};
`

const StoreLocatorContainer = ({ children }) => {
  return <Container>{children}</Container>
}

StoreLocatorContainer.propTypes = {
  children: node.isRequired
}

export default StoreLocatorContainer
